'use client';
import styled, { css } from 'styled-components';
import { fromMd } from '../../constants';
export const StyledAccordionList = styled.div `
  background: ${o => o.$isTransparent
    ? 'transparent'
    : o.$variant === 'dark'
        ? o.theme.color.deprecated.obsidian
        : o.theme.color.fill.background};
  color: ${o => (o.$variant === 'dark' ? 'white' : o.theme.color.text.primary.on.background)};
  margin: 0 auto;
  max-width: 100%;
  padding: 0;
  width: 100%;
`;
export const StyledAccordionHeaderContainer = styled.button `
  align-items: center;
  background: ${o => o.$isTransparent
    ? 'transparent'
    : o.$variant === 'dark'
        ? o.theme.color.deprecated.obsidian
        : o.theme.color.fill.background};
  border-bottom: ${o => o.$showBorder && !o.$currentActive
    ? o.$variant === 'dark'
        ? '1px solid rgba(255, 255, 255, 0.3)'
        : `1px solid ${o.theme.color.stroke.neutral.border.decoration.on.background}`
    : '1px solid transparent'};
  border-top: ${o => o.$showBorder && o.$index === 0
    ? o.$variant === 'dark'
        ? '1px solid rgba(255, 255, 255, 0.3)'
        : `1px solid ${o.theme.color.stroke.neutral.border.decoration.on.background}`
    : 'none'};
  display: flex;
  padding: 24px;
  width: 100%;
  transition: ${o => o.$withAnimation && !o.$currentActive && 'border-bottom 0.5s'};

  &[aria-expanded='true'] {
    background: ${o => o.$isTransparent
    ? 'transparent'
    : o.$variant === 'dark'
        ? '#19191d'
        : o.theme.color.fill.background};
  }
`;
export const StyledAccordionHeader = styled.div `
  flex-basis: 95%;
`;
export const StyledAccordionHeaderControl = styled.div `
  flex-basis: 5%;
  text-align: right;
`;
export const StyledAccordionHeaderIcon = styled.span ``;
export const StyledAccordionBodyContainer = styled.div `
  background: ${o => o.$isTransparent
    ? 'transparent'
    : o.$variant === 'dark'
        ? '#19191d'
        : o.theme.color.fill.background};
  border-bottom: ${o => o.$showBorder && o.$currentActive
    ? o.$variant === 'dark'
        ? 'solid 0.5px rgba(255, 255, 255, 0.3)'
        : `1px solid ${o.theme.color.stroke.neutral.border.decoration.on.background}`
    : 'none'};
  max-height: ${o => (o.$currentActive ? '2000px' : 0)};
  opacity: ${o => (o.$currentActive ? 1 : 0)};
  overflow: hidden;

  ${o => o.$withAnimation &&
    css `
      transition:
        max-height
          ${o.$currentActive ? '0.5s ease-in' : '0.5s cubic-bezier(0.01, 0.97, 0.33, 1.04)'},
        opacity 0.5s linear,
        padding 0s linear 0.5s,
        padding linear 0.2s;
    `}

  padding-left: ${o => o.theme.spacing(6)};
  padding-right: ${o => o.theme.spacing(6)};
  padding-bottom: ${o => (o.$currentActive ? o.theme.spacing(6) : '0')};

  ${fromMd} {
    padding-left: 0;
    padding-right: 0;
  }
`;
export const StyledAccordionListItem = styled.div `
  &:first-child {
    > ${StyledAccordionHeaderContainer}, > ${StyledAccordionBodyContainer} {
      border-top: none;
    }
  }

  &:last-child {
    > ${StyledAccordionHeaderContainer}, > ${StyledAccordionBodyContainer} {
      border-bottom: none;
    }
  }
`;
export const AccordionStyles = {
    BodyContainer: StyledAccordionBodyContainer,
    Header: StyledAccordionHeader,
    HeaderContainer: StyledAccordionHeaderContainer,
    HeaderControl: StyledAccordionHeaderControl,
    HeaderIcon: StyledAccordionHeaderIcon,
    List: StyledAccordionList,
    ListItem: StyledAccordionListItem,
};
//# sourceMappingURL=styles.js.map